const constants = {
  IS_XPO: 'XPO_FEATURE_FLAG',
};
export { constants };
